import React, { useEffect, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import ButtonBot from "shared/components/ButtonBot";
import SearchBar from "shared/components/SearchBar";
const ParkingSettingOfManager = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchText, setSearchText] = useState("");
  const [parkingItems, setParkingItems] = useState([
    {
      id: 1,
      name: "사마용시장",
      itemId: "01-002",
      entryDate: "2024-01-05",
      exitDate: "2024-01-05",
      isChecked: false,
    },
    {
      id: 2,
      name: "사마용시장",
      itemId: "01-003",
      entryDate: "2024-01-05",
      exitDate: "2024-01-05",
      isChecked: false,
    },
    {
      id: 3,
      name: "사마용시장",
      itemId: "01-004",
      entryDate: "2024-01-05",
      exitDate: "2024-01-05",
      isChecked: false,
    },
  ]);

  // Handle new parking data from form
  useEffect(() => {
    if (
      location.state &&
      location.state.parkingName &&
      location.state.managementNumber
    ) {
      // Check if this is an edit or a new item
      const existingItemIndex = parkingItems.findIndex(
        (item) => item.itemId === location.state.managementNumber
      );

      if (existingItemIndex >= 0) {
        // This is an edit, update the existing item
        setParkingItems((prevItems) => {
          const newItems = [...prevItems];
          newItems[existingItemIndex] = {
            ...newItems[existingItemIndex],
            name: location.state.parkingName,
            exitDate: location.state.editDate,
            // Update any other fields that might have changed
          };
          return newItems;
        });
      } else {
        // This is a new item
        const newParking = {
          id: parkingItems.length + 1,
          name: location.state.parkingName,
          itemId: location.state.managementNumber,
          entryDate: location.state.creationDate,
          exitDate: location.state.editDate,
          isChecked: false,
          parkingSpaces: location.state.parkingSpaces || "",
          price: location.state.price || "1층",
          // Include other properties from your form
        };
        setParkingItems((prevItems) => [...prevItems, newParking]);
      }
    }
  }, [location.state]);

  // Function to handle checkbox selection
  const handleCheckboxChange = (id) => {
    setParkingItems((prevItems) =>
      prevItems.map((item) =>
        item.id === id ? { ...item, isChecked: !item.isChecked } : item
      )
    );
  };

  // Check if at least one checkbox is selected
  const isAnyChecked = parkingItems.some((item) => item.isChecked);

  // Function to navigate to edit form
  const handleEdit = (item) => {
    // Convert parkingItems data structure to ParkingFormAdd data structure
    const parkingData = {
      managementNumber: item.itemId,
      parkingName: item.name,
      parkingSpaces: item.parkingSpaces,
      price: item.price,
      creationDate: item.entryDate,
      editDate: item.exitDate,
      // Include any other fields needed by the form
    };

    // Navigate to the form with the data
    navigate("/parking_form_add", {
      state: {
        parkingData: parkingData,
        isEdit: true,
      },
    });
  };

  const [selectAll, setSelectAll] = useState(false);

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleSelectAllChange = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    const updatedItems = parkingItems.map((item) => ({
      ...item,
      isChecked: newSelectAll,
    }));
    setParkingItems(updatedItems);
  };

  useEffect(() => {
    const allChecked = parkingItems.every((item) => item.isChecked);
    // const anyChecked = parkingItems.some((item) => item.isChecked);
    setSelectAll(allChecked);
  }, [parkingItems]);

  const hasSelectedItems = parkingItems.some((item) => item.isChecked);

  const handleDelete = () => {
    const remainingItems = parkingItems.filter((item) => !item.isChecked);
    setParkingItems(remainingItems);
    setSelectAll(false);
  };
  const handleAddOrUpdateParking = () => {
    const selectedItem = parkingItems.find((item) => item.isChecked);
    if (!selectedItem) {
      navigate("/parking_add_form");
    } else {
      // Convert parkingItems data structure to ParkingFormAdd data structure
      const parkingData = {
        managementNumber: selectedItem.itemId,
        parkingName: selectedItem.name,
        parkingSpaces: selectedItem.parkingSpaces,
        price: selectedItem.price,
        creationDate: selectedItem.entryDate,
        editDate: selectedItem.exitDate,
        // Include any other fields needed by the form
      };

      // Navigate to the form with the data
      navigate("/parking_add_form", {
        state: {
          parkingData: parkingData,
          isEdit: true,
        },
      });
    }
  };
  return (
    <div className="parking-setting-container ">
      <SearchBar />
      <div className="htContent">
        <div className="search-filters">
          <div className="filter-labels">
            <input
              type="checkbox"
              id="selectAllCheckbox"
              checked={selectAll}
              onChange={handleSelectAllChange}
            />
            <span>차량번호</span>
            <span>입차일시</span>
            <span>출차일시</span>
            <span>미납금액</span>
          </div>

          {parkingItems.map((item) => (
            <div className="filter-item" key={item.id}>
              <input
                type="checkbox"
                id={`parkingCheckbox-${item.id}`}
                checked={item.isChecked}
                onChange={() => handleCheckboxChange(item.id)}
              />
              <label htmlFor={`parkingCheckbox-${item.id}`}>{item.name}</label>
              <span className="item-id ml-3">{item.itemId}</span>
              <span className="date">{item.entryDate}</span>
              <span className="date">{item.exitDate}</span>
            </div>
          ))}
        </div>
        <ButtonBot
          textYes={`${isAnyChecked ? "수정하기" : "추가하기"}`}
          textNo="삭제하기"
          handleYes={handleAddOrUpdateParking}
          handleNo={handleDelete}
          disabled={!hasSelectedItems}
          className={`delete-button ${hasSelectedItems ? "active" : "disabled"}`}
        />
        
      </div>

    </div>
  );
};

export default ParkingSettingOfManager;
